export const AMPLITUDE_EVENTS = {
  PURCHASE_CTA_CLICKED: 'purchase cta clicked',
  CONFIRM_PURCHASE_CLICKED: 'confirm purchase clicked',
  PURCHASE_CONFIRMATION_VIEWED: 'purchase confirmation viewed',
}

export const EVENT_GET_STARTED_VIEWED = 'Get Started Page Viewed'; // √
export const EVENT_LOGIN_SUCCESSFUL = 'Login Successful'; // √
export const EVENT_LOGIN_FAILED = 'Login Failed'; // √
export const EVENT_SIGN_UP_SUCCESSFUL = 'Sign-up Successful'; // √
export const EVENT_SIGN_UP_FAILED = 'Sign-up Failed'; // √
export const EVENT_LOGOUT = 'Logout'; // √
export const EVENT_FORGOT_PASSWORD = 'Forgot Password'; // √
export const EVENT_ACCOUNT_CREATION_STARTED = 'Account Creation Started'; // √
export const EVENT_ACCOUNT_INFO_FILLED = 'Account Info Filled'; // √

// Account Deletion Flow
export const EVENT_ACCOUNT_DELETION_CTA = 'Account Deletion CTA';
export const EVENT_ACCOUNT_DELETION_CONTINUE_CTA = 'Account Deletion Continue CTA';
export const EVENT_ACCOUNT_DELETION_CONFIRMED = 'Account Deletion Confirmed';

// Content events
export const EVENT_CONTENT_PLAYED = 'Content Played'; // √
export const EVENT_CONTENT_PAUSED = 'Content Paused'; // √
export const EVENT_CONTENT_RESUMED = 'Content Resumed'; // √ 
export const EVENT_CONTENT_SEEKBAR_MOVED = 'Content Seekbar Moved'; // √

// ARTIST
export const EVENT_ARTIST_PAGE_VIEWED = 'Artist Page Viewed'; // √
export const EVENT_CONTENT_SESSION_STARTED = 'Content Session Started';
export const EVENT_CONTENT_SESSION_ENDED = 'Content Session Ended';

// PAYMENT
export const EVENT_PURCHASE_CTA_CLICKED = 'Purchase CTA Clicked'; // √
export const EVENT_CONFIRM_SUBSCRIPTION_PURCHASE_CLICKED = 'Confirm Subscription Purchase Clicked'; // √
export const EVENT_PURCHASE_SUCCESSFUL = 'Purchase Successful'; // √